export const FilterOperationsEnum = {
    // Valid for ['System.Int32', 'System.Double, 'System.DateTime']
    GreaterThan: 1,
    // Valid for ['System.Int32', 'System.Double, 'System.DateTime']
    LessThan: 2,
    // Valid for ['System.Int32', 'System.Double, 'System.DateTime']
    GreaterThanOrEqual: 3,
    // Valid for ['System.Int32', 'System.Double, 'System.DateTime']
    LessThanOrEqual: 4,
    // Valid for ['System.Int32', 'System.Double, 'System.DateTime', 'System.String']
    Equal: 5,
    // Valid for ['System.Int32', 'System.Double, 'System.DateTime', 'System.String']
    NotEqual: 6,
    // Valid for ['System.String']
    StartsWith: 7,
    // Valid for ['System.String']
    EndsWith: 8,
    // Valid for ['System.String']
    Includes: 9,
};

export const DATA_TYPES = {
    Double: 'System.Double',
    Int: 'System.Int32',
    String: 'System.String',
};
export const INPUT_TYPES = {
    DropDownForm: 'DropDownForm',
    TextBox: 'TextBox',
    ComboBox: 'ComboBox',
    MonthCalendar: 'MonthCalendar',
    CheckBox: 'CheckBox',
    NumericUpDown: 'NumericUpDown',
    ProgressBar: 'ProgressBar',
};
export const DATE_FORMATS = {
    D: 'PPPP', // Wednesday, March 12, 2008
    d: 'P', // 3/12/2008
    G: undefined, // Default for app
    g: 'Pp', // 3/12/2008 11:07 AM
    f: 'PPPPp',
    F: 'PPPPpp',
    m: 'LLLL d',
    s: "y-MM-dd'T'HH:mm:ss",
    T: 'pp',
    t: 'p',
    u: "y-MM-dd HH:mm:ss'Z'",
    U: 'PPPPpp',
    y: 'LLLL, y',
};
